<template>
    <div :class="getCSSClass('music-contributor-manager-container')">
        <div :class="getCSSClass('music-contributor-manager-header')">
            <h4 v-html="icon('music-contributors')+translate('Előadók')"></h4>
        </div>
        <div v-for="row, rowIndex in value"
             :class="getCSSClass('music-contributor-manager-row')"
        >
            <div :class="getCSSClass('music-contributor-manager-column-first')" v-html="row.label"></div>
            <div :class="getCSSClass('music-contributor-manager-column-second')">
                <template v-if="row['inputfield']">
                    <div :class="getCSSClass('music-contributor-manager-input-field-container')">
                        <input v-if="row.type == 'text'"
                               type="text"
                               v-model="fields[rowIndex]"
                               v-on:input="emitValue"
                               v-on:change="emitValue"
                               :class="getCSSClass('music-contributor-manager-input-field')"
                        >
                        <repository-file-picker v-if="row.type == 'RepositoryFilePicker'"
                               v-model="fields[rowIndex]"
                               v-on:input="emitValue"
                               v-on:change="emitValue"
                               v-bind="row.props"
                        ></repository-file-picker>
                        <div v-if="errors[row.inputfield]"
                             :class="getCSSClass('music-contributor-manager-error-div', 'w-full py-4 text-red-500')"
                             v-html="errors[row.inputfield][0]"
                        ></div>
                    </div>
                </template>
                <template v-else>
                    <template v-if="!row.multiple">
                        <add-or-pick
                                :multiple="false"
                                v-model="fields[rowIndex]"
                                :urls="row.urls"
                                :label-property="'fullname'"
                                v-on:input="emitValue"
                        ></add-or-pick>

                    </template>
                    <template v-if="row.multiple">
                        <multi-picker
                                v-model="fields[rowIndex]"
                                :urls="row.urls"
                                :label-property="'fullname'"
                                v-on:input="emitValue"
                        ></multi-picker>
                    </template>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            value: {type: Array},
            errors: {type: Object, default: () => {return {}}}
        },
        data: function () {
            return {
                fields: [],
            }
        },
        created() {
            this.setFields();
        },
        mounted() {
        },
        methods: {
            emitValue: function() {
                this.$emit('input', this.currentValue);
            },
            setFields: function() {
                this.value.forEach((row, index) => {
                    Vue.set(this.fields, index, row.value);
                })
            }
        },
        computed: {
            currentValue: function() {
                let result = this.value
                this.fields.forEach((field, fieldIndex) => {
                    result[fieldIndex].value = field;
                });

                return result;
            }
        },
        watch: {}

    }
</script>
